// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__KbufQ","info":"UpdateTermsInfo_info__2XOG9"};